module.exports = __webpack_public_path__ + "static/media/best-selling-web-icon.f511758f.svg";